import React from 'react';
import { Smartphone, Globe, Moon, RefreshCw, Sparkles, FileText, CreditCard, Info, List, Calendar, DollarSign, MoreHorizontal } from 'lucide-react';
import { StatsCard } from './StatsCard';
import { SearchBar } from './SearchBar';
import { SubscriptionTable } from './SubscriptionTable';
export function Dashboard() {
  const stats = [{
    title: 'Monthly Spend',
    amount: '$298.25',
    subtitle: '6 active subscriptions',
    icon: RefreshCw
  }, {
    title: 'Lifetime Purchases',
    amount: '$0.00',
    subtitle: '0 lifetime purchases',
    icon: Sparkles
  }, {
    title: 'Annual Projection',
    amount: '$3,579.00',
    subtitle: 'Based on current active subscriptions',
    icon: FileText
  }, {
    title: 'Active Subscriptions',
    amount: '6',
    subtitle: '6 total',
    icon: CreditCard
  }, {
    title: 'Upcoming Renewals',
    amount: '0',
    subtitle: 'Due in the next 7 days',
    icon: Info
  }];
  return <div className="min-h-screen bg-[#0a0a0a] ml-[60px]" data-id="element-7">
      {/* Top Header */}
      <header className="fixed top-0 right-0 left-[60px] bg-[#0a0a0a]/80 backdrop-blur-sm border-b border-[#1a1a1a] z-40" data-id="element-8">
        <div className="flex items-center justify-end gap-4 px-8 py-4" data-id="element-9">
          <button className="text-gray-400 hover:text-white transition-colors" data-id="element-10">
            <Smartphone size={20} data-id="element-11" />
          </button>
          <button className="text-gray-400 hover:text-white transition-colors" data-id="element-12">
            <Globe size={20} data-id="element-13" />
          </button>
          <button className="text-gray-400 hover:text-white transition-colors" data-id="element-14">
            <Moon size={20} data-id="element-15" />
          </button>
        </div>
      </header>

      {/* Main Content */}
      <main className="pt-20 px-16 pb-16" data-id="element-16">
        {/* Page Title Section */}
        <div className="flex items-start justify-between mb-8" data-id="element-17">
          <div data-id="element-18">
            <h1 className="text-4xl font-bold text-white mb-2" data-id="element-19">
              My Subscriptions
            </h1>
            <p className="text-gray-500 text-sm" data-id="element-20">
              Manage and track all your recurring payments in one place
            </p>
          </div>
          <button className="bg-gradient-to-r from-orange-500 to-orange-600 text-black font-medium px-6 py-3 rounded-full hover:shadow-lg hover:shadow-orange-500/20 transition-all duration-200" data-id="element-21">
            + Add Subscription
          </button>
        </div>

        {/* View Toggle Buttons */}
        <div className="flex items-center justify-between mb-8" data-id="element-22">
          <div className="flex items-center gap-3" data-id="element-23">
            <button className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-orange-500 text-black font-medium shadow-lg shadow-orange-500/20 transition-all duration-200" data-id="element-24">
              <List size={16} data-id="element-25" />
              List
            </button>
            <button className="flex items-center gap-2 px-5 py-2.5 rounded-lg border border-[#333333] text-gray-400 hover:text-white hover:border-gray-600 transition-all duration-200" data-id="element-26">
              <Calendar size={16} data-id="element-27" />
              Calendar
            </button>
            <div className="w-px h-6 bg-[#333333] mx-2" data-id="element-28" />
            <button className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-orange-500 text-black font-medium shadow-lg shadow-orange-500/20 transition-all duration-200" data-id="element-29">
              <DollarSign size={16} data-id="element-30" />
              Monthly
            </button>
            <button className="flex items-center gap-2 px-5 py-2.5 rounded-lg border border-[#333333] text-gray-400 hover:text-white hover:border-gray-600 transition-all duration-200" data-id="element-31">
              <Calendar size={16} data-id="element-32" />
              Annual
            </button>
          </div>

          <button className="flex items-center gap-2 px-5 py-2.5 rounded-lg border border-[#333333] text-gray-400 hover:text-white hover:border-gray-600 transition-all duration-200" data-id="element-33">
            More actions
            <MoreHorizontal size={16} data-id="element-34" />
          </button>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-5 gap-5 mb-8" data-id="element-35">
          {stats.map((stat, index) => <StatsCard key={index} {...stat} data-id="element-36" />)}
        </div>

        {/* Search and Table */}
        <div className="mt-8" data-id="element-37">
          <SearchBar data-id="element-38" />
          <SubscriptionTable data-id="element-39" />
        </div>
      </main>
    </div>;
}